import React from "react";
import { Link } from "react-router-dom";
import { displayDate } from "src/utils/dateHandler.util";
import { PopulatedRequestedCountry } from "../karma-exchanges.service";

interface Props {
  requests: PopulatedRequestedCountry[];
}

const RequestedCountriesTable: React.FC<Props> = ({ requests }) => {
  return (
    <div className="overflow-x-auto mb-6">
      <table className="min-w-full border border-gray-200 divide-y divide-gray-200">
        <thead className="bg-gray-800 text-white text-center">
          <tr>
            <th className="px-4 py-3">User Profile</th>
            <th className="px-4 py-3">Country Code</th>
            <th className="px-4 py-3">Created At</th>
            <th className="px-4 py-3">Updated At</th>
          </tr>
        </thead>

        <tbody>
          {requests.length === 0 && (
            <tr>
              <td colSpan={4} className="px-4 py-6 text-center text-xl text-gray-500">
                No requested countries found
              </td>
            </tr>
          )}

          {requests.map((request) => (
            <tr key={request.id} className="odd:bg-white even:bg-gray-50 hover:bg-gray-100">
              <td className="px-4 py-3 border-t border-gray-200">
                {request.user ? (
                  <Link
                    to={`/users/${request.userId}`}
                    className="flex items-center gap-3 no-underline text-gray-900 hover:opacity-80 transition-opacity"
                  >
                    {request.user.pictureURL ? (
                      <img
                        src={request.user.pictureURL}
                        alt={`${request.user.name} profile`}
                        className="w-10 h-10 rounded-full object-cover border border-gray-200"
                      />
                    ) : (
                      <div className="w-10 h-10 rounded-full bg-gray-200 text-gray-600 flex items-center justify-center font-semibold">
                        {request.user.name.charAt(0).toUpperCase()}
                      </div>
                    )}
                    <div className="text-left">
                      <p className="font-semibold text-gray-900">{request.user.name}</p>
                      <p className="text-sm text-gray-500">{request.user.email || request.user.id}</p>
                    </div>
                  </Link>
                ) : (
                  <div className="text-left">
                    <p className="font-semibold text-gray-700">Unknown user</p>
                    <p className="text-sm text-gray-500">{request.userId}</p>
                  </div>
                )}
              </td>
              <td className="px-4 py-3 border-t border-gray-200 text-center font-medium">{request.countryCode}</td>
              <td className="px-4 py-3 border-t border-gray-200 text-center">
                {request.createdAt ? displayDate(request.createdAt) : "—"}
              </td>
              <td className="px-4 py-3 border-t border-gray-200 text-center">
                {request.updatedAt ? displayDate(request.updatedAt) : "—"}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default RequestedCountriesTable;
